import * as React from 'react';
import { Col, ControlLabel, FormControl, FormGroup, HelpBlock, Row } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import LanguageSelect from '../../components/common/LanguageSelect';
import FieldInfoIcon from '../../components/common/FieldInfoIcon';
import FormValidationService from '../../shared/form/FormValidationService';
import FormSelect from '../../components/common/FormSelect';
import CountryCodePhoneNumberInput from '../../components/common/CountryCodePhoneNumberInput';
import IImageEditorInput from './IImageEditorInput';
import IImageEditorFirm from './IImageEditorFirm';

interface IImageEditorUserFormProps {
    imageEditor: IImageEditorInput;
    onChange: (e: any) => void;
    editId: number;
    errors: any;
    isEditMode: boolean;
    imageEditorFirms: IImageEditorFirm[];
    availableLanguages: any[];
    availableRoles: any[];
}

const ImageEditorUserForm = (props: IImageEditorUserFormProps) => {
    const { apiUrl } = window.appConfig;

    return (
        <form>
            <Row>
                <Col md={props.imageEditor.profileImageReference ? 8 : 12}>
                    <FormGroup
                        className="required"
                        validationState={FormValidationService.getValidationState(
                            props.errors.name
                        )}
                    >
                        <ControlLabel>{Translate('image-editor/list/header/name')}</ControlLabel>
                        <FormControl
                            autoFocus
                            type="text"
                            name="name"
                            value={props.imageEditor.name ? props.imageEditor.name : ''}
                            onChange={props.onChange}
                        />
                        {props.errors && <HelpBlock>{props.errors.name}</HelpBlock>}
                    </FormGroup>
                    <FormGroup
                        className="required"
                        validationState={FormValidationService.getValidationState(
                            props.errors ? props.errors.role : ''
                        )}
                    >
                        <ControlLabel>{Translate('image-editor/list/header/role')}</ControlLabel>
                        <FormSelect
                            name="role"
                            value={props.imageEditor.role ? props.imageEditor.role.toString() : ''}
                            placeholder=""
                            onChange={props.onChange}
                            defaultTranslateKey="image-editors/form/role-select/items/instructions"
                        >
                            {props.availableRoles.map((x: any) => {
                                return (
                                    <option key={x.id} value={x.id}>
                                        {Translate(x.name)}
                                    </option>
                                );
                            })}
                        </FormSelect>
                        {props.errors && <HelpBlock>{props.errors.role}</HelpBlock>}
                    </FormGroup>
                    <FormGroup
                        className="required"
                        validationState={FormValidationService.getValidationState(
                            props.errors.username
                        )}
                    >
                        <ControlLabel>
                            {Translate('image-editor/modal/form/input-label/username')}
                        </ControlLabel>
                        <FormControl
                            type="text"
                            name="username"
                            value={props.imageEditor.username ? props.imageEditor.username : ''}
                            onChange={props.onChange}
                        />
                        {props.errors && <HelpBlock>{props.errors.username}</HelpBlock>}
                    </FormGroup>
                    <FormGroup
                        className="required"
                        validationState={FormValidationService.getValidationState(
                            props.errors.email
                        )}
                    >
                        <ControlLabel>
                            {Translate('image-editor/modal/form/input-label/email-address')}
                        </ControlLabel>
                        <FormControl
                            type="email"
                            name="email"
                            value={
                                props.imageEditor.email
                                    ? props.imageEditor.email
                                    : props.imageEditor.username
                            }
                            onChange={props.onChange}
                        />
                        {props.errors && <HelpBlock>{props.errors.email}</HelpBlock>}
                    </FormGroup>
                    <FormGroup
                        validationState={FormValidationService.getValidationState(
                            props.errors.phoneNumber
                        )}
                    >
                        <ControlLabel>
                            {Translate('image-editor/modal/form/input-label/phone-number')}
                        </ControlLabel>
                        <FieldInfoIcon
                            title={Translate('popover/info/title/phonenumber')}
                            content={Translate('popover/info/content/phonenumber')}
                        />
                        <CountryCodePhoneNumberInput
                            value={props.imageEditor.phoneNumber}
                            onChange={(val) =>
                                props.onChange({
                                    target: { name: 'phoneNumber', value: val }
                                })
                            }
                        />
                        {props.errors && <HelpBlock>{props.errors.phoneNumber}</HelpBlock>}
                    </FormGroup>
                    <FormGroup
                        className="required"
                        validationState={FormValidationService.getValidationState(
                            props.errors.imageEditorFirmId
                        )}
                    >
                        <ControlLabel>
                            {Translate('image-editor/modal/form/select-label/image-editor-firm')}
                        </ControlLabel>
                        <FormSelect
                            name="imageEditorFirmId"
                            onChange={props.onChange}
                            value={
                                props.imageEditor.imageEditorFirmId
                                    ? props.imageEditor.imageEditorFirmId.toString()
                                    : ''
                            }
                            defaultTranslateKey="image-editor/modal/form/select-default/choose-firm"
                        >
                            {props.imageEditorFirms.map((t: { id: number; name: string }) => {
                                return (
                                    <option key={t.id} value={t.id.toString()}>
                                        {t.name}
                                    </option>
                                );
                            })}
                        </FormSelect>
                        <HelpBlock>{props.errors.imageEditorFirmId}</HelpBlock>
                    </FormGroup>
                    <LanguageSelect
                        onChange={props.onChange}
                        languageKey={props.imageEditor.languageKey}
                        errors={props.errors}
                        languages={props.availableLanguages}
                    />
                </Col>
                {props.imageEditor.profileImageReference && (
                    <Col className="profile-image-preview" md={3}>
                        <img src={`${apiUrl}/file/${props.imageEditor.profileImageReference}`} />
                    </Col>
                )}
            </Row>
        </form>
    );
};

export default ImageEditorUserForm;
